/**
 * Cookiekeuze met doelgroepknoppen: combineert de Avada-cookie-acceptatie met
 * de B2B/B2C-keuze in het eerste scherm (verzoek Ivo 01-09, voorbeeld
 * dpj-workspace). Zie snippets/iv-consent-audience.liquid voor de markup.
 *
 * - Toont alleen zolang het avada_cookie_consent-cookie ontbreekt (accepteren
 *   en weigeren zetten dat allebei) en nooit in de theme-editor.
 * - "Bedrijf"/"Particulier": doelgroep via window.IVAudience.set(), daarna de
 *   echte accepteer-knop van Avada (.Avada-CookiesBar_BtnAgree) aanklikken
 *   zodra die gerenderd is (de app injecteert traag, tot ~15 s; gemeten
 *   02-09: de klik zet het volledige consent-cookie en de balk ruimt zichzelf
 *   op). Tot die klik houdt html.iv-ca-pending de balk onzichtbaar.
 * - "Cookies beheren" (of Escape, of een klik naast de kaart): dit scherm weg,
 *   de gewone Avada-balk zichtbaar; zonder keuze verschijnt dit scherm op de
 *   volgende pagina opnieuw, precies zoals een consentbanner hoort.
 * - Rendert de balk nooit (adblocker of app uit), dan stopt het wachten na
 *   ~30 s: de doelgroepkeuze blijft staan, consent blijft aan Avada.
 *
 * EIGEN "AL BEANTWOORD"-VLAG (Ivo 24-10): de balk bleef soms bij elk bezoek
 * terugkomen, ook na een duidelijke keuze. accepteerAvada() hangt af van
 * Avada's eigen knop die ergens binnen ~30s verschijnt; laadt de app traag of
 * navigeert de bezoeker meteen door, dan is diens eigen consent-cookie er nog
 * niet en denkt heeftConsent() de volgende paginalading dat er nog niets is
 * gekozen. iv_ca_answered in localStorage onthoudt de keuze zelf, onafhankelijk
 * van of Avada's cookie het heeft gehaald, dus dit scherm komt na een keuze
 * nooit meer terug. Alleen bij "Cookies beheren" blijft het bestaande gedrag
 * (geen keuze = scherm terug) gewoon staan.
 */
(function () {
  'use strict';

  var root = document.getElementById('iv-consent-audience');
  if (!root) return;

  var BEANTWOORD_KEY = 'iv_ca_answered';

  function heeftConsent() {
    return /(?:^|;\s*)avada_cookie_consent=/.test(document.cookie);
  }

  function alBeantwoord() {
    try {
      return window.localStorage.getItem(BEANTWOORD_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function onthoudKeuze() {
    try {
      window.localStorage.setItem(BEANTWOORD_KEY, '1');
    } catch (e) {
      /* privébrowsing of opslag uit: dan blijft Avada's eigen cookie de bron. */
    }
  }

  if (heeftConsent() || alBeantwoord() || (window.Shopify && window.Shopify.designMode)) {
    root.remove();
    return;
  }

  var html = document.documentElement;
  html.classList.add('iv-ca-open');
  root.hidden = false;
  var eersteKnop = root.querySelector('button');
  if (eersteKnop) eersteKnop.focus();

  function sluit() {
    html.classList.remove('iv-ca-open');
    root.remove();
    document.removeEventListener('keydown', opToets);
  }

  function accepteerAvada() {
    var pogingen = 0;
    (function poging() {
      var balk = document.getElementById('Avada-CookiesBar') || document.getElementById('Avada-CookiesBarMobile');
      var knop = balk && balk.querySelector('.Avada-CookiesBar_BtnAgree');
      if (knop) {
        knop.click();
        html.classList.remove('iv-ca-pending');
        return;
      }
      pogingen += 1;
      if (pogingen > 120) {
        /* Balk komt niet (adblocker of app uit): consent blijft aan Avada. */
        html.classList.remove('iv-ca-pending');
        return;
      }
      setTimeout(poging, 250);
    })();
  }

  function kies(aud) {
    onthoudKeuze();
    if (window.IVAudience) window.IVAudience.set(aud);
    html.classList.add('iv-ca-pending');
    sluit();
    accepteerAvada();
  }

  function beheer() {
    sluit();
  }

  function opToets(e) {
    if (e.key === 'Escape') beheer();
  }

  root.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-iv-ca]');
    if (!knop) {
      if (e.target === root) beheer();
      return;
    }
    var actie = knop.getAttribute('data-iv-ca');
    if (actie === 'b2b' || actie === 'b2c') kies(actie);
    else beheer();
  });

  document.addEventListener('keydown', opToets);
})();
